module.exports = __webpack_public_path__ + "img/2.d95085a4.jpg";